export default __webpack_public_path__ + "5a82babbc50e74dcb01c2e3f69f22fa7.svg";